import { useTranslations } from 'next-intl';
import { Runtime, useSiteInfo } from '@silvertours/front-entities';
import { String } from '@silvertours/front-shared';
import {
  ContactWrapper,
  ContactTitle,
  ContactText,
  ContactNumber,
  ContactButton,
  PhoneNumberHint,
  PhoneNumberIcon,
} from './ErrorPage.styles';

const Contact = () => {
  const t = useTranslations('features.errorPage');
  const {
    settings: { phoneNumber, language },
    featureToggles,
  } = useSiteInfo();
  const { market } = Runtime.useLocale();

  const formattedNumber = String.parsePhoneNumber(phoneNumber, language);
  const phoneNumberText =
    market === 'CH' ? formattedNumber.international : formattedNumber.national;

  return (
    <ContactWrapper>
      <ContactTitle>{t('contact.title')}</ContactTitle>
      <ContactText>{t('contact.text')}</ContactText>
      {featureToggles.hideInfoline ? (
        <ContactButton href={t('contact.link')}>
          {t('contact.linkText')}
        </ContactButton>
      ) : (
        <>
          <ContactNumber>
            <PhoneNumberIcon />
            {phoneNumberText}
          </ContactNumber>
          {market === 'CH' && (
            <PhoneNumberHint>
              (aus der Schweiz zum Auslandstarif)
            </PhoneNumberHint>
          )}
        </>
      )}
    </ContactWrapper>
  );
};

export { Contact };
